import React, { createContext, useContext, useState, useCallback } from "react";

const PlayerContext = createContext(null);

export const PlayerProvider = ({ children }) => {
  const [current, setCurrent] = useState(null); // album object
  const [open, setOpen] = useState(false);

  const play = useCallback((album) => {
    setCurrent(album);
    setOpen(true);
  }, []);

  const toggle = useCallback(() => setOpen((o) => !o), []);
  const close = useCallback(() => setOpen(false), []);
  const stop = useCallback(() => {
    setOpen(false);
    setCurrent(null);
  }, []);

  return (
    <PlayerContext.Provider value={{ current, open, play, toggle, close, stop }}>
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => {
  const ctx = useContext(PlayerContext);
  if (!ctx) throw new Error("usePlayer must be used inside PlayerProvider");
  return ctx;
};
